var _style, _g, _path, _path2, _path3, _defs, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrequestLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2969 761.3",
    style: {
      enableBackground: "new 0 0 2969 761.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC008C;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000030478738356108660190000012575801377307716737_);}\r\n\t.st3{opacity:0.6;fill:url(#SVGID_00000003074869347220750970000007888912942881658247_);}\r\n\t.st4{fill:url(#SVGID_00000096050558287029028930000005057595379322265239_);}\r\n\t.st5{fill:#2C2B94;}\r\n\t.st6{opacity:0.6;fill:url(#SVGID_00000021830018165491827300000007331928400668406718_);}\r\n\t\r\n\t\t.st7{opacity:0.6;clip-path:url(#SVGID_00000065795820500305069310000010697009946176372903_);fill:url(#SVGID_00000084519466413038082190000015320693706115950260_);}\r\n\t.st8{fill:#100249;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "new"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,47.3C0,100.6,25.1,148,64.3,178.1v0C92,199.3,126.8,212,164.4,212h115.3c69,0.2,132,25.8,180.1,67.9 l0.2,0.2c43.9,38.5,75.4,90.8,87.8,150c24.9-36.1,41.3-78.5,46.5-124.3v0c1.2-10.2,1.8-20.6,1.8-31.2c0-11.7-0.7-23.3-2.2-34.6 c0,0,0-0.1,0-0.1c-1.2-9.5-2.9-18.8-5-28C560.7,90.7,452,0.3,322.2,0H0V47.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.9819,
    y1: 318.4701,
    x2: 358.4445,
    y2: -4.2559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F24CAE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    style: {
      stopColor: "#F24CAE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24CAE"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,47.3C0,100.6,25.1,148,64.3,178.1v0C92,199.3,126.8,212,164.4,212h115.3c69,0.2,132,25.8,180.1,67.9 l0.2,0.2c43.9,38.5,75.4,90.8,87.8,150c24.9-36.1,41.3-78.5,46.5-124.3v0c1.2-10.2,1.8-20.6,1.8-31.2c0-11.7-0.7-23.3-2.2-34.6 c0,0,0-0.1,0-0.1c-1.2-9.5-2.9-18.8-5-28C560.7,90.7,452,0.3,322.2,0H0V47.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134965834304078593930000004861586788117144723_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2848,
    y1: 520.465,
    x2: 460.119,
    y2: 520.465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC008C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    style: {
      stopColor: "#EC008C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC008C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134965834304078593930000004861586788117144723_)"
    },
    d: "M460.1,280.1 c-101.3,49-180.9,135.7-220.8,241.9c-1.7,4.4-3.2,8.8-4.8,13.3c-15.1,44.5-23.3,92.1-23.3,141.7c0,26.5,2.3,52.4,6.8,77.5 c0.4,2.3,0.8,4.5,1.2,6.8H0.3c0,0,0-25.3,0-38.2c0-48.4,7.8-95,22.1-138.6c1.9-5.9,4-11.7,6.1-17.4c17.5-46.6,42.6-89.4,73.8-127 c81.3-98.1,204.1-160.5,341.5-160.5L460.1,280.1C460.2,280.2,460,280.1,460.1,280.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134244287861617151820000002729066306687270840_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.2019,
    y1: 761.3,
    x2: 230.2019,
    y2: 279.63
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C2B94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    style: {
      stopColor: "#2C2B94",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2B94",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000134244287861617151820000002729066306687270840_)"
    },
    d: "M460.1,280.1 c-101.3,49-180.9,135.7-220.8,241.9c-1.7,4.4-3.2,8.8-4.8,13.3c-15.1,44.5-23.3,92.1-23.3,141.7c0,26.5,2.3,52.4,6.8,77.5 c0.4,2.3,0.8,4.5,1.2,6.8H0.3c0,0,0-25.3,0-38.2c0-48.4,7.8-95,22.1-138.6c1.9-5.9,4-11.7,6.1-17.4c17.5-46.6,42.6-89.4,73.8-127 c81.3-98.1,204.1-160.5,341.5-160.5L460.1,280.1C460.2,280.2,460,280.1,460.1,280.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072277013331166726280000004995427122122642083_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.2019,
    y1: 279.63,
    x2: 230.2019,
    y2: 761.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002480909,
    style: {
      stopColor: "#F466BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F466BA",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F466BA",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072277013331166726280000004995427122122642083_)"
    },
    d: "M460.1,280.1 c-101.3,49-180.9,135.7-220.8,241.9c-1.7,4.4-3.2,8.8-4.8,13.3c-15.1,44.5-23.3,92.1-23.3,141.7c0,26.5,2.3,52.4,6.8,77.5 c0.4,2.3,0.8,4.5,1.2,6.8H0.3c0,0,0-25.3,0-38.2c0-48.4,7.8-95,22.1-138.6c1.9-5.9,4-11.7,6.1-17.4c17.5-46.6,42.6-89.4,73.8-127 c81.3-98.1,204.1-160.5,341.5-160.5L460.1,280.1C460.2,280.2,460,280.1,460.1,280.1z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M547.9,430.2c-0.8,1.1-1.5,2.2-2.3,3.3C495.8,503.6,414,549.3,321.5,549.3c-30.4,0-59.6-4.9-86.9-14 c1.5-4.5,3.1-8.9,4.8-13.3c39.9-106.1,119.5-192.8,220.8-241.9C504,318.6,535.5,370.9,547.9,430.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099624424036867746810000014284361480067238534_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.7384,
    y1: 377.084,
    x2: 448.9087,
    y2: 526.2562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC008C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC008C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000099624424036867746810000014284361480067238534_)"
    },
    d: "M547.9,430.2 c-0.8,1.1-1.5,2.2-2.3,3.3C495.8,503.6,414,549.3,321.5,549.3c-30.4,0-59.6-4.9-86.9-14c1.5-4.5,3.1-8.9,4.8-13.3 c39.9-106.1,119.5-192.8,220.8-241.9C504,318.6,535.5,370.9,547.9,430.2z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000131364496323071146570000017873105816286500258_",
    d: "M0,47.3C0,100.6,25.1,148,64.3,178.1v0 C92,199.3,126.8,212,164.4,212h115.3c69,0.2,132,25.8,180.1,67.9l0.2,0.2c43.9,38.5,75.4,90.8,87.8,150 c24.9-36.1,41.3-78.5,46.5-124.3v0c1.2-10.2,1.8-20.6,1.8-31.2c0-11.7-0.7-23.3-2.2-34.6c0,0,0-0.1,0-0.1 c-1.2-9.5-2.9-18.8-5-28C560.7,90.7,452,0.3,322.2,0H0V47.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078756375769880907740000015402269042658983862_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131364496323071146570000017873105816286500258_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080176904044924477100000010565460832960445581_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.8907,
    y1: 330.7219,
    x2: 360.5356,
    y2: -3.4948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C2B94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    style: {
      stopColor: "#2C2B94",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2B94",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      clipPath: "url(#SVGID_00000078756375769880907740000015402269042658983862_)",
      fill: "url(#SVGID_00000080176904044924477100000010565460832960445581_)"
    },
    d: " M596.1,274.7c0-11.7-0.7-23.3-2.2-34.6c0,0,0-0.1,0-0.1c-1.2-9.5-2.9-18.8-5-28C560.7,90.7,452,0.3,322.2,0H0v47.3 c0,1.8-0.1,3.5,0,5.3l-0.2,7.7c0,53.3,25.3,100.6,64.5,130.7v0C92,212.4,126.8,225,164.4,225h115.3c69,0.2,132,25.8,180.1,67.9 l0.2,0.2c43.9,38.5,75.4,90.8,87.8,150c24.9-36.1,41.3-78.5,46.5-124.3v0c1.2-10.2,1.8-20.6,1.8-31.2c0-2.2,0-4.5-0.1-6.7 C596.1,278.9,596.1,276.8,596.1,274.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M955,176.1H801.8c-4.1,0-5.8,1.7-5.8,5.8v360.2c0,4.1,1.7,5.8,5.8,5.8h54c4.1,0,5.8-1.7,5.8-5.8V389H955 c72.5,0,118.4-39.5,118.4-107.3C1073.4,217.3,1029.8,176.1,955,176.1z M949.2,333.9h-87.6v-99.2h87.6c34.2,0,55.1,17.4,55.1,49.3 C1004.3,314.8,984,333.9,949.2,333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1268.8,287.4c-6.4-1.2-13.3-1.7-20.9-1.7c-33.6,0-58.6,12.2-74.3,36v-25.5c0-4.1-1.7-5.8-5.8-5.8h-53.4 c-4.1,0-5.8,1.7-5.8,5.8v247.1c0,4.1,1.7,5.8,5.8,5.8h52.8c4.1,0,5.8-1.7,5.8-5.8l0.6-156.1c13.3-28.4,38.3-42.9,74.3-42.9 c6.4,0,13.3,0.6,19.7,1.7c4.1,0.6,6.4-1.2,6.4-5.2v-47C1274,289.7,1272.2,287.9,1268.8,287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1517.3,314.8c-22.6-22.6-52.8-33.6-90.5-33.6c-40,0-71.9,12.8-96.9,37.7c-24.4,25-36.6,57.4-36.6,98.6 c0,41.8,12.2,75.4,37.1,100.4c25,24.9,58,37.7,99.8,37.7c48.7,0,91.1-19.7,114.9-50.5c1.7-2.9,1.7-5.2-1.2-8.1l-28.4-27.9 c-2.9-2.9-5.8-2.9-8.1,0.6c-16.8,20.9-41.2,31.9-73.7,32.5c-44.1,0-75.4-26.1-76-67.9H1544c4.1,0,5.8-1.7,6.4-5.2 c1.2-7.5,1.7-16.2,1.7-26.1C1552.2,366.4,1540.6,337.4,1517.3,314.8z M1358.4,389.6c4.1-34.2,29-55.1,66.1-55.1 c37.7,0,62.7,22.1,63.3,55.1H1358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2149.9,289.5h-53.4c-4.1,0-5.8,1.7-5.8,5.8v172.9c-13.3,20.3-33.1,30.2-59.8,30.2 c-37.1,0-55.7-20.9-55.7-63.2V295.3c0-4.1-1.7-5.8-5.8-5.8h-52.8c-4.1,0-5.8,1.7-5.8,5.8v150.8c0,69.6,36.5,109.6,99.8,109.6 c31.9,0,58.6-9.9,80.1-29v15.7c0,4.1,1.7,5.8,5.8,5.8h53.4c4.1,0,5.8-1.7,5.8-5.8V295.3C2155.7,291.2,2154,289.5,2149.9,289.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2424,315c-22.6-22.6-52.8-33.6-90.5-33.6c-40,0-71.9,12.8-96.9,37.7c-24.4,25-36.5,57.4-36.5,98.6 c0,41.8,12.2,75.4,37.1,100.4c25,24.9,58,37.7,99.8,37.7c48.7,0,91.1-19.7,114.9-50.5c1.7-2.9,1.7-5.2-1.2-8.1l-28.4-27.9 c-2.9-2.9-5.8-2.9-8.1,0.6c-16.8,20.9-41.2,31.9-73.7,32.5c-44.1,0-75.4-26.1-76-67.9h186.2c4.1,0,5.8-1.7,6.4-5.2 c1.2-7.5,1.7-16.2,1.7-26.1C2458.8,366.6,2447.2,337.6,2424,315z M2265,389.8c4.1-34.2,29-55.1,66.1-55.1 c37.7,0,62.7,22.1,63.3,55.1H2265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2645.8,396.2l-47-11.6c-13.9-2.9-18-4.1-25.5-11c-3.5-4.1-5.2-8.7-5.2-14.5c0-18,13.9-27.3,41.8-27.3 c24.9,0,48.2,6.4,69,18.6c3.5,2.3,5.8,1.7,7.5-2.3l15.1-36c1.7-3.5,0.6-6.4-2.9-8.1c-27.3-15.1-58-22.6-92.2-22.6 c-62.1,0-103.8,33.1-103.8,81.8c0,42.4,26.1,63.8,70.8,74.8l41.8,11c13.3,2.9,18,2.9,25.5,11.6c4.1,4.1,6.4,9.9,6.4,16.2 c0,18.6-15.1,27.8-45.8,27.8c-30.2,0-56.9-7.5-79.5-22.6c-3.5-2.3-5.8-1.7-7.5,1.7l-15.1,36c-1.2,3.5-0.6,5.8,2.3,7.5 c25.5,19.1,59.2,28.4,100.9,28.4c67.9,0,111.4-31.3,111.4-84.1C2713.7,432.8,2691.1,407.2,2645.8,396.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2963.2,289.5h-83V182.1c0-4.1-1.7-5.8-5.8-5.8H2821c-4.1,0-5.8,1.7-5.8,5.8v107.3h-67.9 c-4.1,0-5.8,1.7-5.8,5.8v42.4c0,4.1,1.7,5.8,5.8,5.8h67.9v114.9c0,64.4,34.8,96.9,96.9,96.9c16.2,0,32.5-2.3,48.7-6.4 c3.5-0.6,5.2-2.3,5.2-6.4v-41.8c0-4.6-2.3-6.4-6.4-5.2c-11.6,2.9-21.5,4.1-30.2,4.1c-33.1,0-49.3-16.2-49.3-48.7V343.4h83 c4.1,0,5.8-1.7,5.8-5.8v-42.4C2969,291.2,2967.2,289.5,2963.2,289.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1893.6,573.3l-61.5-68.4c39.8-49,41.3-121-0.1-172.4c-47.6-59.1-133.7-68.6-192.5-21.3 c-58.7,47.3-67.8,133.5-20.2,192.6c42.1,52.3,114.4,65.7,171.2,35.4l53.3,74.3c2.6,3.3,5.6,4.1,9,1.3l40.5-32.6 C1896.2,579.8,1896.1,576.6,1893.6,573.3z M1663.3,468.3c-27.9-34.6-22.6-85.1,11.9-112.8c34.4-27.7,84.9-22.1,112.8,12.5 c27.9,34.6,22.5,85.1-11.9,112.8C1741.6,508.5,1691.1,502.9,1663.3,468.3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrequestLogoColor);
export default __webpack_public_path__ + "static/media/Prequest_logo_color.c5cd9c0e.svg";
export { ForwardRef as ReactComponent };